// Material
import { ListItemText, MenuItem } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledMenuItem = styled(MenuItem)<{ error: boolean; disabled?: boolean }>(
  ({ theme, error }) => ({
    padding: '8px 15px',
    textAlign: 'right',
    color: !error ? 'inherit' : theme.palette.error.main,
    ':hover': {
      backgroundColor: theme.palette.secondary.light,
    },
    marginBottom: '5px',
    ':last-child': {
      marginBottom: 0,
    },
  }),
)

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiListItemText-primary': {
    ...theme.typography.body2,
    color: 'inherit',
  },
}))

interface Props {
  text: string
  loading?: boolean
  onClick: () => unknown
  children: JSX.Element | JSX.Element[]
  error?: boolean
  isDisabled?: boolean
}

export function PopupMenuItem({
  text,
  loading,
  children,
  onClick,
  error = false,
  isDisabled,
}: Props) {
  return (
    <StyledMenuItem
      disabled={isDisabled || loading}
      onClick={onClick}
      error={error}
    >
      {children}
      <StyledListItemText>{text}</StyledListItemText>
    </StyledMenuItem>
  )
}

PopupMenuItem.defaultProps = {
  isDisabled: false,
  loading: false,
  error: false,
}
